import validate from 'validate.js';

const constraints = {
    email: {
	email: {
	    message: 'Napiši email'
	},
	presence: { 
	    message: 'Napiši email'
	}
    }
}

const PasswordResetValidator = ( fields ) => {
    return validate(fields, constraints, {fullMessages: false}) || {};
}

export default PasswordResetValidator ;



// WEBPACK FOOTER //
// ./src/validators/PasswordResetValidator.js